/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
interface Logger {
  log: (message?: any, ...optionalParams: any[]) => void;
  error: (message?: any, ...optionalParams: any[]) => void;
}

class LoggerInit {
  getLogger(): Logger {
    if (this.isDebugActive()) {
      return this.getDebugLogger();
    } else {
      return this.getEmptyLogger();
    }
  }

  private getDebugLogger(): Logger {
    return {
      log: window.console.log.bind(window.console),
      error: window.console.error.bind(window.console)
    };
  }

  private getEmptyLogger(): Logger {
    return {
      log: () => {},
      error: () => {}
    };
  }

  private isDebugActive(): boolean {
    if (
      location.hostname === 'localhost' ||
      location.hostname.includes('sviluppo')
    ) {
      return true;
    }

    const toggle = localStorage.getItem('debug');

    return typeof toggle === 'string' && toggle.toUpperCase() === 'ON';
  }
}

export default new LoggerInit().getLogger();
